var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#0D0D0D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_15230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9789 11.213L16.8054 6.85718H15.8989L12.575 10.6385L9.9221 6.85718H6.86157L10.8741 12.5757L6.86157 17.1429H7.76801L11.2759 13.1488L14.0782 17.1429H17.1387M8.09517 7.52656H9.48772L15.8982 16.5064H14.5053",
    fill: "#0D0D0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_15230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.2771,
    height: 10.2857,
    fill: "white",
    transform: "translate(6.86157 6.85718)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.728c4356e87b46d26edcf5a775f0755e.svg";
export { ForwardRef as ReactComponent };